var lib_core = require("lib-core");

var PosAngleFlipData = require("./../../abstract/posAngleFlipData.js");
var SymbolTerminalData = require("./../../symbol/symbolTerminalData.js");
var SchematicTerminal = require("./schematicTerminal.js");

var SchematicElementData = function (symbolInstance, pos, angle, flip) {
    this.observeAncestor = true;
    this.registerInstanceClass(["terminals"],SymbolTerminalData, SchematicTerminal);
    this.registerInstanceClass(["terminalMap"]);    // TODO: see if we can omit this: find another way to get the mappings.
    lib_core.InstanceBuilder.call(this, symbolInstance);

    this.addPosAngleFlip(pos, angle, flip);

    this.onInit(this, this.initialize);
};
lib_core.inherit(SchematicElementData, lib_core.InstanceBuilder);
lib_core.mixin(SchematicElementData, PosAngleFlipData);
lib_core.JsonParser.registerClass(SchematicElementData, "SchematicElementData");

module.exports = SchematicElementData;

SchematicElementData.prototype.initialize = function () {
    var self = this;

    this.componentInstance = this.ancestor().parent().parent();

    this.nonTransformedBoundingBox = this.shadow("nonTransformedBoundingBox",
        function(){
            var boundingBox = null;
            self.description().shapes.forEach(function(index, element){
                var elementBB = element.boundingBox && element.boundingBox();
                if (elementBB) boundingBox = elementBB.merge(boundingBox);
            });
            self.description().generators.forEach(function(generator) {
                var generatorBB = generator.boundingBox && generator.boundingBox();
                if (generatorBB) boundingBox = generatorBB.merge(boundingBox);
            });
            return boundingBox;
        },
        null,
        [[this, this.onBubble],
         [this.description, this.description.onChange]]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function(){
            var bb = self.nonTransformedBoundingBox();
            return bb.flip(self.xflip())
                     .rotate(self.angle())
                     .translate(self.pos());
        },
        [[this, this.onBubble]]
    );

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",    //TODO: redo wrt rotate
        function(){
            return self.boundingBox().getPoly();
        },
        [[this, this.onBubble]]
    );
};
